var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVersions = function SvgVersions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.967 2C2.881 2 2 2.88 2 3.967v1.967c0 1.087.88 1.968 1.967 1.968h2.295c1.087 0 1.968-.881 1.968-1.968v-.327H9.54c1.086 0 1.967.88 1.967 1.967v8.852a3.28 3.28 0 0 0 3.279 3.279h.765a3.116 3.116 0 0 0 6.12-.82 3.115 3.115 0 0 0-6.19-.492h-.695a1.967 1.967 0 0 1-1.967-1.967v-3.934h2.661a3.116 3.116 0 1 0 .07-1.312H12.82V7.574c0-.738-.244-1.42-.656-1.967h3.317a3.116 3.116 0 1 0 .07-1.312H8.23v-.328C8.23 2.881 7.349 2 6.262 2z"
  })));
};
export default SvgVersions;